<template lang="pug">
  article.flex.flex-col.justify-between.pt-100.md-pt-160.min-h-screen
    section.w-full.md-w-3x4.mx-auto.px-10.md-px-20.content-box
      div(style="max-width:32em")
        slot

    app-footer
</template>

<script>
import AppFooter from '@/components/AppFooter'
export default {
  name: 'PageTemplate',
  components: { AppFooter }
}
</script>

<style>
</style>
